const setApplications = (state, payload) => {
  state.applications = payload
}
const setContextMenu = (state, payload) => {
  state.contextMenu = payload
}
const setContextMenuState = (state, opened = false) => {
  state.contextMenu.isOpen = state.contextMenuOpened = opened
}
const setMarkerIndex = (state, index) => {
  state.markerIndexCount = index
}

export default {
  setApplications,
  setContextMenu,
  setContextMenuState,
  setMarkerIndex
}
